<template>
  <div :id="mapId" :style="apStyle"></div>
</template>

<script>
import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet.wms";
import "leaflet.fullscreen";
import "leaflet.fullscreen/Control.FullScreen.css";
import "leaflet-easybutton";
// cuidado con este que no le gusta al ie11 -> import "leaflet.wmts";

export default {
  name: "app-mapa-inmuebles",
  props: {
    apPoligono: { type: String, required: false },
    apPoligono2: { type: String, required: false },
    apRefGeograficasArray: { type: Array, required: false },
    apStyle: { type: String, required: true }
  },
  data() {
    return {
      center: { lng: 1, lat: 1 },
      polygonsPaths: [],
      map: null // tenemos que alamcenar el mapa para eliminarlo después
    };
  },
  computed: {
    mapId() {
      return "mapa-inmuebles-" + this._uid;
    }
  },
  mounted() {
    // this.readUnidadesMapFromDataAccess();
    this.initMap();
  },
  beforeDestroy() {
    // hay que hacer esto porque si no da un error de que ya ha sido inicializado el mapa leaflet y para que no ocupe más memoria
    this.map.off();
    this.map.remove();
  },
  methods: {
    initMap() {
      if (this.apPoligono) {
        this.polygonsPaths[0] = this.multipolygonString2LeafletArray(
          this.apPoligono
        );

        if (this.apPoligono2) {
          this.polygonsPaths[1] = this.multipolygonString2LeafletArray(
            this.apPoligono2
          );
        }

        if (this.polygonsPaths[0][0]) {
          this.center = this.polygonsPaths[0][0];
        }

        this.map = L.map(this.mapId, {
          minZoom: 6,
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: "topleft"
          },
          forceSeparateButton: true
        }).setView(this.center, 15);

        L.tileLayer(
          "http://www.ign.es/wmts/ign-base?service=WMTS&request=getTile&version=1.0.0&layer=IGNBaseTodo&style=default&tilematrixset=GoogleMapsCompatible&format=image%2Fpng&width=256&height=256&tilematrix={z}&tilerow={y}&tilecol={x}",
          {
            attribution:
              'Datos del mapa © <a href="http://www.ign.es/ign/main/index.do" target="_blank">Instituto Geográfico Nacional de España</a>'
          }
        ).addTo(this.map);

        var url4GoogleMaps =
          "https://www.google.com/maps/search/?api=1&query=" +
          this.center.lat +
          "," +
          this.center.lng;

        var iconImg = require("@/assets/google-maps-icon.png");
        L.easyButton(
          '<img class="ap-icon-open-google-maps" src="' + iconImg + '"></img>',
          function() {
            window.open(url4GoogleMaps);
          },
          "Ver en Google Maps (abrirá otra ventana)"
        ).addTo(this.map);

        // L.easyButton(
        //   '<i class="material-icons ap-icon-open-google-maps">open_in_new</i>',
        //   function() {
        //     window.open(url4GoogleMaps);
        //   },
        //   "Ver en Google Maps (abrirá otra ventana)"
        // ).addTo(this.map);

        // L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        //   attribution:
        //     'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
        // }).addTo(this.map);

        L.polygon(this.polygonsPaths).addTo(this.map);
        // zoom the map to the polygon
        this.map.fitBounds(L.polygon(this.polygonsPaths).getBounds());
        // this.map.setView(this.center, 15);
      } else if (this.apRefGeograficasArray) {
        this.center = { lat: 37.302, lng: -4.678 };

        var leafletMarkers = this.refGeograficasArray2LeafletMarkersArray(
          this.apRefGeograficasArray
        );

        this.map = L.map(this.mapId, {
          minZoom: 6,
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: "topleft"
          },
          forceSeparateButton: true
        }).setView(this.center, 7); // toda andalucia para empezar

        // L.tileLayer
        //   .wms("http://www.callejerodeandalucia.es/servicios/base/wms?", {
        //     layers: ["CDAU_base", "CDAU_toponimia", "nucleos_poblacion"],
        //     format: "image/png",
        //     transparent: true,
        //     continuousWorld: true,
        //     attribution:
        //       '<a href="http://www.callejerodeandalucia.es/portal/web/cdau/" target="_blank">Fuente: CDAU (Entidades Locales-Junta de Andalucía- IGN).</a>'
        //   })
        //   .addTo(this.map);

        // L.tileLayer
        //   .wms("http://www.callejerodeandalucia.es/servicios/cdau/wms?", {
        //     layers: ["CDAU_wms"],
        //     format: "image/png",
        //     transparent: true,
        //     continuousWorld: true,
        //     attribution:
        //       '<a href="http://www.callejerodeandalucia.es/portal/web/cdau/" target="_blank">Fuente: CDAU (Entidades Locales-Junta de Andalucía- IGN).</a>'
        //   })
        //   .addTo(this.map);

        // const url = "http://www.ign.es/wmts/mapa-raster";

        // /** WMTS tile options */
        // const wmtsOptions = {
        //   layer: "MTN",
        //   style: "default",
        //   format: "image/jpeg",
        //   attribution: "&copy;"
        // };

        // const wmts = new L.TileLayer.WMTS(url, wmtsOptions);
        // this.map.addLayer(wmts);

        // L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        // L.tileLayer(
        //   "http://www.ign.es/wmts/mapa-raster?service=WMTS&request=getTile&version=1.0.0&layer=MTN&style=default&tilematrixset=GoogleMapsCompatible&format=image%2Fpng&width=256&height=256&tilematrix={z}&tilerow={y}&tilecol={x}",
        //   {
        //     attribution: "&copy"
        //   }
        // ).addTo(this.map);

        L.tileLayer(
          "http://www.ign.es/wmts/ign-base?service=WMTS&request=getTile&version=1.0.0&layer=IGNBaseTodo&style=default&tilematrixset=GoogleMapsCompatible&format=image%2Fpng&width=256&height=256&tilematrix={z}&tilerow={y}&tilecol={x}",
          {
            attribution:
              'Datos del mapa © <a href="http://www.ign.es/ign/main/index.do" target="_blank">Instituto Geográfico Nacional de España</a>'
          }
        ).addTo(this.map);

        // L.tileLayer(
        //   http://www.callejerodeandalucia.es/servicios/base/gwc/service/wms?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&ISWMC=ok&LAYERS=base&WIDTH=256&HEIGHT=256&SRS=EPSG%3A25830&BBOX=533623.3400564644%2C4162031.1663564644%2C659182.1455955806%2C4287589.97189558
        //   "http://www.ign.es/wmts/pnoa-ma?service=WMTS&request=getTile&version=1.0.0&layer=OI.OrthoimageCoverage&style=default&tilematrixset=GoogleMapsCompatible&format=image%2Fpng&width=256&height=256&tilematrix={z}&tilerow={y}&tilecol={x}",
        //   {
        //     attribution: "&copy"
        //   }
        // ).addTo(this.map);

        var markers = L.markerClusterGroup();

        leafletMarkers.forEach(marker => {
          markers.addLayer(marker);
        });

        this.map.addLayer(markers);

        var group = new L.featureGroup(leafletMarkers);

        this.map.fitBounds(group.getBounds());
      }
    },
    refGeograficasArray2LeafletMarkersArray(refGeograficasArray) {
      var leafletMarkersArray = [];

      refGeograficasArray.forEach(currentRef => {
        if (currentRef.c) {
          let marker = this.refGeografica2LeafletMarker(currentRef);

          if (marker) {
            leafletMarkersArray.push(marker);
          }
        }
      });

      return leafletMarkersArray;
    },
    refGeografica2LeafletMarker(refGeografica) {
      var returnedMarker;
      var processedString;
      var self = this;
      var centroideString = refGeografica.c;
      var referenciaInmueble = refGeografica.r;
      var tipoInmueble = refGeografica.t;
      var htmlIconConVideo =
        refGeografica.v && refGeografica.v === "S"
          ? `<i class="material-icons mdc-chip__icon mdc-chip__icon--leading">video_library</i>`
          : "";
      var htmlIconConFicha =
        refGeografica.f && refGeografica.f === "S"
          ? `<i class="material-icons mdc-chip__icon mdc-chip__icon--leading">library_books</i>`
          : "";

      switch (tipoInmueble) {
        case "SI":
          tipoInmueble = "SUELO INDUSTRIAL";
          break;
        case "SR":
          tipoInmueble = "SUELO RESIDENCIAL";
          break;
        case "G":
          tipoInmueble = "GARAJE";
          break;
        case "L":
          tipoInmueble = "LOCAL";
          break;
        case "ST":
          tipoInmueble = "SUELO TERCIARIO";
          break;
        case "NI":
          tipoInmueble = "NAVE INDUSTRIAL";
          break;
        case "T":
          tipoInmueble = "TRASTERO";
          break;
        case "PA":
          tipoInmueble = "PARCELA APARCAMIENTO";
          break;
        case "SD":
          tipoInmueble = "SUELO DOTACIONAL";
          break;
        default:
          break;
      }
      var estadoIcon =
        refGeografica.o && refGeografica.o === "S"
          ? "thumb_up"
          : "contact_support";
      var mutiles = refGeografica.m ? refGeografica.m + " m²" : "";

      try {
        // Hay que transformarlo, Loren lo guarda así vete a saber por qué... es un "demonio malo" ;)
        processedString = centroideString
          .replace(/\(+/g, '{"lng":')
          .replace(/\)+/g, "}")
          .replace(/,/g, '}, {"lng":')
          .replace(/ +{/g, "{")
          .replace(/ +/g, ',"lat":');
        var latlng = JSON.parse(processedString);

        var popupHtmlContent = `<div style="text-align:center"">
            <i style="position:relative; bottom: 3px" class="material-icons mdc-chip__icon mdc-chip__icon--leading"> ${estadoIcon} </i> <span style="font-weight: bold">${tipoInmueble}</span><br><span>Ref: "${referenciaInmueble}"</span><br>
            <span> ${mutiles} </span> 
            <div style="margin-top:1em">${htmlIconConVideo} ${htmlIconConFicha}</div>
            </div>`;

        var markerPopup = L.popup({ closeButton: false }).setContent(
          popupHtmlContent
        );

        returnedMarker = new L.Marker(latlng).bindPopup(markerPopup);

        returnedMarker.on("mouseover", function() {
          this.openPopup();
        });

        returnedMarker.on("mouseout", function() {
          this.closePopup();
        });

        returnedMarker.on("click", function() {
          // var params = {
          //   id: referenciaInmueble
          // };
          // Se emite evento para que lo capture componente contenedor y lo trate
          self.$emit("mapMarkerClicked", referenciaInmueble);
          // self.$router.push({
          //   name: "inmuebles-detail",
          //   params: params
          // });
        });
      } catch (e) {
        // console.log(
        //   "Error: processedString",
        //   processedString,
        //   "refGeografica",
        //   refGeografica
        // );
        this.$mdApp.log.error(e);
        returnedMarker = null;
      }

      return returnedMarker;
    },
    multipolygonString2LeafletArray(multipolygonFormatString) {
      var processedString;
      var returnedArray = [];

      try {
        processedString = multipolygonFormatString
          .replace(/MULTIPOLYGON\(+/g, '[{"lng":')
          .replace(/\)+/g, "}]")
          .replace(/,/g, '}, {"lng":')
          .replace(/ +{/g, "{")
          .replace(/ +/g, ',"lat":');

        returnedArray = JSON.parse(processedString);
      } catch (e) {
        this.$mdApp.log.error(e);
      }

      return returnedArray;
    },
    polygonsPathsArray2LeafletPolygonsArray(polygonsPaths) {
      var leafletPolygonsArray = [];

      for (var currentIndex in polygonsPaths) {
        var currentReferenciaUnidad = polygonsPaths[currentIndex];
        var multipolygonFieldValue = currentReferenciaUnidad.poligono;

        if (multipolygonFieldValue) {
          // Hay que procesarlo, pues viene una cadena
          leafletPolygonsArray[
            currentIndex
          ] = this.multipolygonString2LeafletArray(multipolygonFieldValue);
        }
      }
    }

    // ,
    // watch: {
    //   apFilterTerms() {
    //     this.readUnidadesMapFromDataAccess();
    //   }
    // }
  }
};
</script>

<style lang="scss">
/* .ap-icon-open-google-maps {
  position: relative;
  bottom: -0.1em;
  left: -0.15em;
} */
.leaflet-bar.easy-button-container.leaflet-control {
  // border: none;

  button.easy-button-button {
    padding: 0px;

    .button-state.state-unnamed-state.unnamed-state-active {
      width: 100%;
      height: 100%;
    }
  }
}

.ap-icon-open-google-maps {
  width: 100%;
  height: 100%;
}
</style>
